module.exports = __webpack_public_path__ + "img/product-card-01.a1f436c.webp";